import React from 'react';
import Icon, { Icons } from '@shared/Icons/Icon';
import { isMobileOrTablet } from '../../../../../utils/browserDetection';
import { cross } from './styles.module.css';

const ClearFilterButton = ({ onClick }) => {
  if (isMobileOrTablet()) {
    return null;
  }

  return (
    <Icon className={cross} icon={Icons.CROSS.THIN_RED} onClick={onClick} />
  );
};

export default ClearFilterButton;
